import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromTurnovers from '@main-application/turnovers/reducers/turnovers.reducer';

export const selectTurnoversState = createFeatureSelector<fromTurnovers.State>(fromTurnovers.turnoversFeatureKey);

/**
 * get created turnover id
 */
export const selectCreatedTurnover = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.createdTurnover
);
export const selectCreateTurnoverLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.createTurnoverLoading
);

/**
 * get turnover data
 */
export const selectTurnoverData = createSelector(selectTurnoversState, turnoversState => turnoversState.turnoverData);
export const selectTurnoverUnitName = createSelector(selectTurnoverData, turnoverData => turnoverData?.unitName);
export const selectTurnoverDataId = createSelector(selectTurnoverData, turnoverData => turnoverData?.id);
export const selectUpdatedTurnoverData = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updatedTurnoverData
);
export const selectTurnoverDataLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.turnoverDataLoading
);
export const selectEmptyTurnoverData = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.emptyTurnoverData
);

/**
 * Set workflow step
 */
export const selectSetWorkflowStepLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.setWorkflowStepLoading
);
export const selectSetWorkflowStepStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.setWorkflowStepStatus
);
export const selectNextWorkflowStep = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.nextWorkflowStep
);

/**
 * get current workflow step
 */

export const selectCurrentWorkflowStep = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.currentWorkflowStep
);
/**
 * get current workflow step model
 */

export const selectCurrentWorkflowStepModel = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.currentWorkflowStepModel
);

/**
 * get appliance type list
 */
export const selectApplianceTypeList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.applianceTypeList
);

/**
 * get color type list
 */
export const selectColorTypeList = createSelector(selectTurnoversState, turnoversState => turnoversState.colorTypeList);

/**
 *  select NewApplianceNeededLoading
 */

export const selectIsNewApplianceNeededAdd = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.isNewApplianceNeededAdd
);

export const selectAddNewApplianceNeededLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addNewApplianceNeededLoading
);

/**
 * get user list
 */
export const selectUserList = createSelector(selectTurnoversState, turnoversState => turnoversState.userList);

export const selectAllUserRadioList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.allUserRadioList
);

export const selectAllUserList = createSelector(selectTurnoversState, turnoversState => turnoversState.allUserList);

export const selectListModel = createSelector(selectTurnoversState, turnoversState => turnoversState.userListModel);

/**
 * get company radio list
 */
export const selectCompanyRadioList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.companyRadioList
);
export const selectCompanyNameRadioList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.companyNameRadioList
);
export const selectCompanyEmailRadioList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.companyEmailRadioList
);

/**
 * select Added Attachment
 */
export const selectAddedAttachment = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addedAttachment
);

export const selectAddedBidAttachment = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addedBidAttachment
);

export const selectAddBidAttachmentInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addBidAttachmentInProgress
);

export const selectAddBidAttachmentStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addBidAttachmentStatus
);

export const selectAddedTicketAttachment = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addedTicketAttachment
);

export const selectAddTurnoverAttachmentStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addTurnoverAttachmentStatus
);

export const selectAddTurnoverAttachmentInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.addTurnoverAttachmentInProgress
);
/**
 * select update attachment
 */

export const selectUpdateTurnoverAttachmentInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updateTurnoverAttachmentInProgress
);

export const selectUpdateTurnoverAttachmentStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updateTurnoverAttachmentStatus
);

/**
 * select remove attachment
 */

export const selectDeleteTurnoverAttachmentInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.deleteTurnoverAttachmentInProgress
);

/**
 * Is new bid added
 */
export const selectNewBidList = createSelector(selectTurnoversState, turnoversState => turnoversState.newBidList);
export const selectNewBidListInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.newBidListInProgress
);

/**
 * turnover ticket
 */
export const selectTurnoverTicketList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.turnoverTicketList
);

export const selectTurnoverTicketListLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.turnoverTicketListLoading
);

export const selectUpdateTicketInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updateTicketInProgress
);

/**
 *  select newTurnoverTicket
 */
export const selectNewTurnoverTicket = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.newTurnoverTicket
);
export const selectNewTurnoverTicketLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.newTurnoverTicketLoading
);

/**
 *  select updated Turnover Ticket
 */
export const selectUpdatedTurnoverTicket = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.editedTicket
);
export const selectSelectedTicket = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.selectedTicket
);
export const selectSelectedTicketLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.selectedTicketLoading
);

/**
 * get company list
 */
export const selectCompanyList = createSelector(selectTurnoversState, turnoversState => turnoversState.companyList);
export const selectCompanyListLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.companyListLoading
);

/**
 * get bid turnover list
 */
export const selectBidTurnoverList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.bidTurnoverList
);
export const selectBidTurnoverListLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.bidTurnoverListLoading
);

/**
 * get bid turnover list
 */
export const selectAllBidList = createSelector(selectTurnoversState, turnoversState => turnoversState.allBidList);
export const selectAllBidListLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.allBidListLoading
);

/**
 * get bid company list
 */
export const selectBidCompanyList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.bidCompanyList
);
export const selectBidCompanyListLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.bidCompanyListLoading
);

/**
 * get turnover attachments
 */
export const selectAllAttachments = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.allAttachments
);
export const selectAllAttachmentsLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.allAttachmentsLoading
);

/**
 * get bid
 */
export const selectBid = createSelector(selectTurnoversState, turnoversState => turnoversState.bid);
export const selectBidLoading = createSelector(selectTurnoversState, turnoversState => turnoversState.bidLoading);
export const selectUpdatedBid = createSelector(selectTurnoversState, turnoversState => turnoversState.updatedBid);
export const selectUpdatedBidLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updatedBidLoading
);
export const selectUpdatedBidCommentLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updatedBidCommentLoading
);

export const selectRejectBidLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.rejectBidLoading
);

/**
 * delete bid attachment
 */
export const selectDeleteBidAttachmentInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.deleteBidAttachmentInProgress
);
export const selectDeleteBidAttachmentStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.deleteBidAttachmentStatus
);

/**
 * select bid attachment list
 */
export const selectBidAttachments = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.bidAttachments
);
export const selectBidAttachmentsLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.bidAttachmentsLoading
);

/**
 * get appliance
 */
export const selectAppliance = createSelector(selectTurnoversState, turnoversState => turnoversState.appliance);
export const selectApplianceLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.applianceLoading
);

/**
 * get workflow step comment
 */
export const selectWorkflowStepCommentList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.workflowStepCommentList
);
export const selectWorkflowStepCommentListLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.workflowStepCommentListLoading
);
export const selectWorkflowStepCommentUpdateLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.workflowStepCommentUpdateLoading
);

/* get worflow assignment responsible part id */
export const selectWorkflowAssignmentAssigneeId = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.workflowStepAssigneeId
);
export const selectWorkflowAssignmentLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.workflowStepAssignmentLoading
);

export const selectReloadAppliancesNeeded = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.reloadAppliancesNeeded
);

/**
 * delete turnover
 */

export const selectDeleteTurnoverInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.deleteTurnoverInProgress
);

export const selectTurnoverDeleteStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.turnoverDeleteStatus
);

export const selectStepInfo = createSelector(selectTurnoversState, turnoversState => turnoversState.stepInfo);

/**
 * get ticket
 */
export const selectTicket = createSelector(selectTurnoversState, turnoversState => turnoversState.ticket);
export const selectTicketLoading = createSelector(selectTurnoversState, turnoversState => turnoversState.ticketLoading);

/**
 * get ticket attachments
 */
export const selectTicketAttachments = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.ticketAttachments
);
export const selectTicketAttachmentsLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.ticketAttachmentsLoading
);

/**
 * update ticket preview
 */
export const selectTicketUpdateInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.ticketUpdateInProgress
);
export const selectTicketUpdateInProgressStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.ticketUpdateInProgressStatus
);

export const selectInspectTurnoverId = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.inspectTurnoverId
);

export const selectValidationParams = createSelector(selectTurnoversState, turnoversState => ({
  lockFields: turnoversState.validationParams.lockFields,
  nextStepAvailable: turnoversState.validationParams.nextStepAvailable && turnoversState.validationParams.saveAvailable,
  nextStepChecking: turnoversState.validationParams.nextStepChecking,
  saveAvailable: turnoversState.validationParams.saveAvailable,
  customMessage: turnoversState.validationParams.customMessage,
}));

/**
 * counters
 */

export const selectAllPropertyIds = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.allPropertyIds
);

export const selectActivePropertyIds = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.activePropertyIds
);

export const selectIsActiveSection = propertyId =>
  createSelector(selectActivePropertyIds, activePropertyIds => activePropertyIds.includes(propertyId));

export const selectInactiveFilteredPropertyIds = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.inactiveFilteredPropertyIds
);

export const selectIsInactiveFilteredSection = propertyId =>
  createSelector(selectInactiveFilteredPropertyIds, inactiveFilteredPropertyIds =>
    inactiveFilteredPropertyIds.includes(propertyId)
  );

/**
 *  update step assignee
 */
export const selectUpdateStepAssigneeInProgress = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updateStepAssigneeInProgress
);

export const selectUpdateStepAssigneeStatus = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.updateStepAssigneeStatus
);

/**
 *  default Turnovers Assignees
 */
export const selectDefaultTurnoversAssignees = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.defaultTurnoversAssignees
);

export const selectDefaultTurnoversAssigneesLoading = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.defaultTurnoversAssigneesLoading
);

export const selectDisplayedPropertyList = createSelector(
  selectTurnoversState,
  turnoversState => turnoversState.displayedPropertyList
);

export const selectSectionsLostRevenue = createSelector(
  selectTurnoversState,
  turnoverState => turnoverState.sectionsLostRevenue
);

export const selectTurnoverTimers = createSelector(selectTurnoversState, turnoverState => turnoverState.timers);
